import { useCallback, useState } from "react";

export const useSearchActions = () => {
	const [searchText, setSearchText] = useState("");

	const handleChangeSearchText = useCallback((value: string) => {
		setSearchText(value);
	}, []);

	return {
		searchText,
		handleChangeSearchText,
	};
};
